import { render, staticRenderFns } from "./UDIrukuChildNew.vue?vue&type=template&id=2c06a451&scoped=true"
import script from "./UDIrukuChildNew.vue?vue&type=script&lang=js"
export * from "./UDIrukuChildNew.vue?vue&type=script&lang=js"
import style0 from "./UDIrukuChildNew.vue?vue&type=style&index=0&id=2c06a451&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06a451",
  null
  
)

export default component.exports